import React from 'react';
import PropTypes from 'prop-types';
import s from './NoSearchResultsGradebook.module.css';
const emptyImgUrl = new URL(
  '../../../../assets/empty_view.png',
  import.meta.url,
).href;

const NoSearchResultsGradebook = ({ searchPhrase }) => {
  const headerText = 'No search results found';
  const subheaderText = `There are no students with the first name, last name, or email that match ${searchPhrase}`;
  return (
    <div className={s.emptyView}>
      <p className={s.emptyViewTitle}>{headerText}</p>
      <p className={s.emptyViewText}>{subheaderText}</p>
      <img
        src={emptyImgUrl}
        alt="empty view"
        className={s.emptyViewImg}
        data-test-id="empty-view-image"
      />
    </div>
  );
};

NoSearchResultsGradebook.propTypes = {
  searchPhrase: PropTypes.string,
};

export default NoSearchResultsGradebook;
